<template>
  <!-- 404-Page -->
  <div class="page-404">
    <div class="vertical-center">
      <div class="text-center">
        <h1>404!</h1>
        <h5>We can't seem to find the page you're looking for.</h5>
        <div class="redirect-link-wrapper u-s-p-t-25">
          <a class="redirect-link" href="/">
            <span>Home</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- 404-Page /- -->
</template>
<script>
export default {};
</script>

<style>
</style>